export const services = [
  {
    id: 'reiki',
    name: 'Intuitive Reiki — Tune & Restore',
    slug: 'reiki',
    tagline: 'Energy tune-up for returning clients',
    price: 140,
    duration: '1 hour',
    description: 'A focused energy tune-up for returning clients who are familiar with Reiki. This session supports maintenance, recalibration, and gentle realignment of your energy field. Ideal if you\'re seeking quick restoration, emotional balance, or relief from stress. Includes a short check-in and practical aftercare suggestions.',
    benefits: [
      'Quick energy restoration and recalibration',
      'Gentle realignment of your energy field',
      'Emotional balance and stress relief',
      'Maintenance of energetic wellbeing',
      'Practical aftercare guidance'
    ],
    whatToExpect: [
      'Brief check-in to understand current needs',
      'Comfortable relaxation in a peaceful environment',
      'Focused Reiki energy work',
      'Gentle realignment techniques',
      'Aftercare suggestions for ongoing balance'
    ],
    testimonials: [
      {
        text: "After my Reiki session with Kirstie, I felt lighter and more grounded. The combination of crystals and aromatherapy made it a truly healing experience.",
        author: "Sarah M."
      },
      {
        text: "I came in feeling anxious and left feeling calm and balanced. Kirstie's intuitive approach is exactly what I needed.",
        author: "James L."
      }
    ],
    image: null
  },
  {
    id: 'reiki-intro',
    name: 'Intuitive Reiki — Intro & Integrate',
    slug: 'reiki-intro',
    tagline: 'Extended session for those new to energy healing',
    price: 180,
    duration: '90 minutes',
    description: 'An extended session designed for those new to energy healing or who prefer a gentler, unhurried pace. We begin with a thoughtful intake to understand what\'s present, follow with a restorative Reiki treatment, and close with grounding integration and guidance.',
    benefits: [
      'Gentle introduction to energy healing',
      'Unhurried, nurturing pace',
      'Deep restorative treatment',
      'Grounding integration techniques',
      'Comprehensive guidance for your journey'
    ],
    whatToExpect: [
      'Thoughtful intake conversation',
      'Understanding of what\'s present for you',
      'Extended restorative Reiki treatment',
      'Crystal and aromatherapy enhancement',
      'Grounding integration',
      'Guidance for continued healing'
    ],
    testimonials: [
      {
        text: "As someone completely new to Reiki, the extended session was perfect. Kirstie took the time to explain everything and I felt so supported throughout.",
        author: "Michelle R."
      },
      {
        text: "The 90-minute session gave me space to truly relax and receive. I left feeling transformed.",
        author: "Peter K."
      }
    ],
    image: null
  },
  {
    id: 'deep-release',
    name: 'Deep Release & Rebalance',
    slug: 'deep-release',
    tagline: 'An immersive 2-hour energy healing experience',
    price: 240,
    duration: '2 hours',
    description: 'This 2-hour session offers an immersive experience for those seeking a profound journey into energy healing. We begin with an in-depth intake to explore your current challenges and intentions, followed by an extensive Reiki treatment tailored to your unique needs. The session includes deeper energetic work to facilitate significant release of blockages and emotional tension. We\'ll conclude with grounding practices and personalised strategies to help you maintain balance and integrate the healing energy, ensuring you leave feeling revitalised and aligned.',
    benefits: [
      'In-depth exploration of challenges and intentions',
      'Extensive tailored Reiki treatment',
      'Significant release of blockages and emotional tension',
      'Deeper energetic work for profound healing',
      'Personalised strategies for maintaining balance',
      'Complete revitalisation and alignment'
    ],
    whatToExpect: [
      'Comprehensive in-depth intake conversation',
      'Exploration of current challenges and intentions',
      'Extensive Reiki treatment tailored to your needs',
      'Deeper energetic work for blockage release',
      'Grounding practices',
      'Personalised integration strategies'
    ],
    testimonials: [
      {
        text: "The 2-hour Deep Release session was exactly what I needed. The extended time allowed for such profound healing work that I felt completely transformed.",
        author: "Sarah T."
      },
      {
        text: "Kirstie's deep release session helped me release emotional tension I'd been carrying for years. The personalised aftercare strategies have been invaluable.",
        author: "Mark W."
      }
    ],
    image: null
  },
  {
    id: 'tarot',
    name: 'Intuitive Tarot Readings',
    slug: 'tarot',
    tagline: 'Clarity and guidance for your life journey',
    price: 120,
    duration: '1 hour',
    description: 'Tarot sessions use intuition and the imagery of the cards rather than rigid meanings. Each reading begins by setting an intention, connecting to energy and interpreting the symbols and messages. Tarot is a tool for empowerment and guidance.',
    benefits: [
      'Gain clarity on current life situations',
      'Uncover hidden patterns and obstacles',
      'Receive actionable insights and guidance',
      'Empowerment through self-awareness',
      'Validation and confirmation of your path'
    ],
    whatToExpect: [
      'Setting your intention for the reading',
      'Connecting to your energy field',
      'Card interpretation using intuition',
      'Discussion of symbols and messages',
      'Practical guidance for moving forward',
      'Optional recording of your session'
    ],
    testimonials: [
      {
        text: "Kirstie's readings are incredibly accurate and uplifting. She helped me see patterns I was blind to and gave me the confidence to make important changes.",
        author: "Emma R."
      },
      {
        text: "The insight I gained from my tarot session was exactly what I needed to hear. Kirstie has a true gift.",
        author: "Michael K."
      }
    ],
    image: null
  },
  {
    id: 'soul-coaching',
    name: 'Soul Alignment Coaching',
    slug: 'soul-coaching',
    tagline: 'Align with your true purpose',
    price: 140,
    duration: '1 hour',
    description: 'Designed to awaken the profound understanding within you and reignite your connection to your higher self. In a warm and nurturing environment, Kirstie delves into the depths of your soul\'s purpose, illuminating the unique path you are meant to walk on this Earth. By recognising and embracing the divine light that connects us all, you will gain clarity and insight into your true essence.\n\nThrough a tailored coaching approach, an energetic grid is created that supports your personal journey, allowing you to flow harmoniously with the universe. This grid acts as a conduit for attracting greater peace and abundance into your life, aligning your energy with your desires and intentions. Together, you will explore your individual needs and situations, empowering you to tap into the infinite possibilities available to you. Step into your light and discover the transformative power of Soul Alignment Coaching to cultivate a life of fulfilment, joy, and purpose.',
    benefits: [
      'Breakthrough mental and emotional blocks',
      'Improved self-worth and confidence',
      'Alignment with life purpose',
      'Tools for ongoing personal growth',
      'Integration of mind, body and spirit'
    ],
    whatToExpect: [
      'Deep exploration of current challenges',
      'Identification of root causes',
      'Guided meditation and visualization',
      'Personalised exercises and practices',
      'Journaling prompts for self-discovery',
      'Ongoing support and accountability'
    ],
    testimonials: [
      {
        text: "Working with Kirstie changed my life. She helped me uncover the root of my struggles and gave me practical tools to create lasting change.",
        author: "Lisa T."
      },
      {
        text: "The soul alignment coaching went beyond anything I expected. I finally feel like I'm living in alignment with my true purpose.",
        author: "David S."
      }
    ],
    image: null
  },
  {
    id: 'chakra',
    name: 'Chakra Healing',
    slug: 'chakra',
    tagline: 'Balance your energy centres',
    price: 180,
    duration: '90 minutes',
    description: 'A 90-minute session aligns and harmonises the seven chakras using Reiki, crystals, guided meditation and breathwork. You are encouraged to notice physical sensations and emotional patterns throughout the session.',
    benefits: [
      'Release energy blockages',
      'Improved energy flow throughout the body',
      'Enhanced emotional balance',
      'Greater self-awareness',
      'Deep sense of calm and wellbeing'
    ],
    whatToExpect: [
      'Assessment of your current chakra state',
      'Guided meditation to center your energy',
      'Reiki energy work on each chakra',
      'Crystal placement and healing',
      'Breathwork techniques',
      'Post-session integration and guidance'
    ],
    testimonials: [
      {
        text: "After my chakra healing session, I felt more balanced than I have in years. Kirstie's expertise is evident in every aspect of the work.",
        author: "Rachel W."
      },
      {
        text: "The improved mood and calmness I experienced after chakra balancing has stayed with me. This work is truly transformative.",
        author: "Nathan P."
      }
    ],
    image: null
  },
  {
    id: 'space-clearing',
    name: 'Space Clearing',
    slug: 'space-clearing',
    tagline: 'Cleanse and harmonize your environment',
    price: 'Price on enquiry',
    duration: 'Varies by space',
    description: 'Kirstie clears homes, offices or other spaces of accumulated negative energy. She connects with source energy and nature spirits to shift stagnant energies and restore balance to your environment.',
    benefits: [
      'Improved wellbeing and harmony',
      'Enhanced mental clarity',
      'Better sleep and relaxation',
      'Positive energy flow in your space',
      'Fresh start after major life changes'
    ],
    whatToExpect: [
      'Initial assessment of your space',
      'Connection with source and nature spirits',
      'Clearing of negative energies',
      'Blessing and protection of the space',
      'Recommendations for maintenance',
      'Follow-up guidance as needed'
    ],
    testimonials: [
      {
        text: "After Kirstie cleared our home, the energy completely shifted. We all sleep better and the space feels light and welcoming.",
        author: "The Johnson Family"
      },
      {
        text: "Our office felt heavy and unproductive. After the clearing, the team's mood improved dramatically. Highly recommend!",
        author: "Corporate Client"
      }
    ],
    image: null
  },
  {
    id: 'restorative-reiki',
    name: 'Restorative Reiki Classes',
    slug: 'restorative-reiki',
    tagline: 'A sanctuary for healing and self-discovery',
    price: 'Varies',
    duration: '90 minutes',
    description: 'Restorative Reiki classes are a unique sanctuary for healing, self-discovery, and personal growth. These small, intimate classes create a nurturing cocoon of Reiki energy, allowing you to immerse fully into the healing process. A supportive space designed to facilitate deep relaxation and healing. Release emotional blockages and limiting beliefs, foster a sense of freedom and lightness. Experience the profound transformation that comes from letting go and trusting the healing energy of Reiki. The classes integrate techniques that open your senses, helping you connect deeply with your body, mind, and spirit. You\'ll cultivate greater awareness of your inner landscape, enhancing your overall well-being. Through meditation, movement, and the channelling of Reiki energy, you will find opportunities to expand your awareness and align with your true self. These classes are limited to 5 people.',
    benefits: [
      'Deep relaxation and healing in intimate setting',
      'Release of emotional blockages and limiting beliefs',
      'Foster freedom and lightness within',
      'Deep connection with body, mind, and spirit',
      'Expanded awareness and alignment with true self'
    ],
    whatToExpect: [
      'Small intimate class of maximum 5 participants',
      'Nurturing cocoon of Reiki energy',
      'Guided meditation and gentle movement',
      'Channelling of healing Reiki energy',
      'Techniques to open your senses',
      'Integration and grounding to close'
    ],
    testimonials: [
      {
        text: "The intimate setting of these classes creates such a powerful healing space. I leave feeling completely transformed.",
        author: "Kelly M."
      },
      {
        text: "Being in a small group allows for such deep, personal healing. The Reiki energy Kirstie channels is truly profound.",
        author: "Tom B."
      }
    ],
    image: null
  },
  {
    id: 'guided-ascension',
    name: 'Guided Ascension: 6-Week Energy Healing Experience',
    slug: 'guided-ascension',
    tagline: 'Transform and reconnect with your higher consciousness',
    price: 1199,
    duration: '6 weeks',
    description: 'Embark on a transformative journey with this 6-week program designed to reconnect you to your inner self and higher consciousness. Each week, experience the healing power of energy sessions tailored to your unique needs, alongside insightful guidance in hour-long Zoom or in-person sessions.\n\nThroughout this program, you will cultivate a deeper connection to your intuition and the wisdom of your guides. By the end, you\'ll be empowered to receive constant messages from your spiritual allies, establish a solid foundation for meditation and grounding practices, and effortlessly clear any heavy energies in your space.\n\nJoin Kirstie to unlock your potential, embrace your spiritual gifts, and step into a life filled with clarity and purpose. Begin your journey of alignment and healing today!',
    benefits: [
      'Deep reconnection to your inner self and higher consciousness',
      'Personalised energy healing sessions each week',
      'Stronger connection to intuition and spiritual guides',
      'Foundation for ongoing meditation and grounding practices',
      'Tools to effortlessly clear heavy energies',
      'Empowerment to embrace your spiritual gifts'
    ],
    whatToExpect: [
      'Weekly 1-hour sessions (Zoom or in-person)',
      'Personalised energy healing tailored to your needs',
      'Guidance on connecting with your spiritual guides',
      'Meditation and grounding practice foundations',
      'Energy clearing techniques for your space',
      'Ongoing support throughout your 6-week journey'
    ],
    testimonials: [
      {
        text: "This 6-week journey completely transformed my relationship with my intuition. I now feel deeply connected to my guides and receive their wisdom daily.",
        author: "Amanda R."
      },
      {
        text: "Kirstie's guided ascension program gave me the tools I needed to finally feel grounded and clear. I can't recommend this experience enough.",
        author: "Sophie L."
      }
    ],
    image: null
  }
];

export const getServiceBySlug = (slug) => {
  return services.find(service => service.slug === slug);
};
